import { Map as map } from 'immutable';
const C = require("../constants");

function ProductsSaleReducer(state = map(), action) {
    let products_sale = [];
    switch (action.type) {
        case C.PRODUCTS_SALE:
            return action.products_sale;

        case C.PRODUCT_SALE_QUANTITY:
            products_sale = state.map(product_sale => {
                product_sale.quantity = product_sale.id === action.product_sale.id ? (product_sale.quantity+action.product_sale.quantity):product_sale.quantity;
                return product_sale
            });
            return products_sale;

        case C.PRODUCT_SALE_ADD:
            return state.concat(action.product_sale);

        case C.PRODUCT_SALE_DELETE:
            products_sale = state.filter(product_sale => {
                return product_sale.id !== action.product_sale
            });
            return products_sale;

        default:
            return state;
    }
}

export default ProductsSaleReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProductsSaleReducer.js